<div
  *ngIf="!isLoading && session"
  class="w-full lg:max-w-full lg:flex login-page"
  class="w-full lg:max-w-full lg:flex login-page"
>
  <div
    class="bg-cover bg-center bg-no-repeat lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r pt-6 w-full card-form"
    style="
      background-image: url('assets/img/01-BG_AC_Force_N.png');
      background-size: cover;
      background-position: center;
      background-attachment: fixed;
    "
  >
    <div class="w-4/5 grid-cols-1 flex place-content-center">
      <app-card-form style="opacity: 0.9">
        <div id="page-one">
          <div class="flex justify-between mb-10">
            <div
              class="logo-icon"
              style="background-image: url('assets/img/logo_unchk.png')"
            ></div>
            <div
              class="logo-icon"
              style="background-image: url('assets/img/logo_master_card.png')"
            ></div>
          </div>
          <div class="flex justify-center items-center">
            <div class="text-center">
              <span class="font-bold text-2xl">
                FORMULAIRE DE PARTICIPATION À L'ACTIVITE :
                {{ activity.nomActivity }}
              </span>
              <br />
              Programme Force-N
            </div>
          </div>
          <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
          <div class="flex justify-center items-center">
            <div class="text-center">
              <!-- <span class="underline text-blue-800"
                ><a
                  href="https://sciences.force-n.sn/course/index.php?categoryid=2/"
                  target="_blank"
                  >Vous souhaitez en savoir plus avant de vous inscrire? Cliquez
                  ici pour obtenir plus de détails sur ce programme .</a
                >
              </span>
              <br /> -->
              <br />
              <br />
              <span class="font-bold text-2xl">
                L'activité se tiendra à partir du
              </span>
              <br />
              <br />
              {{ activity.openDate | date : "EEEE d MMMM y, " }} dans les ENO de
              : Saint-Louis, Kolda, Kaolack, Mbour
              <!-- : {{ activity.adresse }}  -->
              à partir de 9h:00.
              <!-- {{ date | date : "EEEE d MMMM y" }} -->
            </div>
          </div>
        </div>

        <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
          <form [formGroup]="jpoForm" class="space-y-6">
            <div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl">
                  I. INFORMATIONS PERSONNELLES</span
                >
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="grid md:grid-cols-3 md:gap-6 my-6">
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Prénom - Nom &nbsp;
                      <p style="color: red">*</p>
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group">
                  <input
                    type="text"
                    id="prenom"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                    [formControl]="prenomCtrl"
                  />
                  <div class="mt-3">
                    <p>Prénom</p>
                  </div>
                </div>
                <div class="relative z-0 w-full group">
                  <input
                    type="text"
                    id="nom"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                    [formControl]="nomCtrl"
                  />
                  <div class="mt-3">
                    <p>Nom</p>
                  </div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 m-0 md:gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:me-3">
                      Sexe
                      <span style="color: red">*</span>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedSexe')"
                      style="color: #eb1c1c"
                    >
                      Champ requis !
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center">
                    <input
                      formControlName="gender"
                      id="gender"
                      type="radio"
                      value="Homme"
                      name="gender"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('gender') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="gender"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Masculin</label
                    >
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center">
                    <input
                      formControlName="gender"
                      id="gender"
                      value="Féminin"
                      type="radio"
                      name="gender"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('gender') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="gender"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Féminin</label
                    >
                  </div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Adresse email &nbsp;
                      <p style="color: #ff0000">*</p>
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <input
                      type="email"
                      id="email"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                      [formControl]="emailCtrl"
                      placeholder="Par ex : monnom@exemple.com"
                    />
                  </div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 md:gap-6 my-6">
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Numéro de téléphone &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('telephone')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group">
                  <input
                    type="text"
                    id="indicatif"
                    [formControl]="indicatifCtrl"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                  />
                  <div class="mt-3">
                    <p>Indicatif pays</p>
                  </div>
                </div>
                <div class="relative z-0 w-full group">
                  <input
                    type="tel"
                    id="telephone"
                    maxlength="9"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                    formControlName="telephone"
                    onlyNumber
                    [style.border]="
                      isFieldInvalid('telephone') ? '2px solid #eb1c1c' : ''
                    "
                  />
                  <div class="mt-3">
                    <p>Numéro de téléphone</p>
                  </div>
                </div>
              </div>
              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Votre lieu de provenance(région) &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div *ngIf="isFieldInvalid('lieu')" style="color: #eb1c1c">
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="lieu"
                      id="region"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('lieu') ? '2px solid #eb1c1c' : ''
                      "
                    >
                      <option
                        *ngFor="let region of regions"
                        [value]="region.name"
                      >
                        {{ region.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl"
                  >II. CHOIX LIEU DE L'ACTIVITE</span
                >
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="grid md:grid-cols-3 m-0 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:me-3">
                      Je participerai a l'activite de
                      <span style="color: red">*</span>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('lieuDeParticipation')"
                      style="color: #eb1c1c"
                    >
                      Champ requis !
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-2">
                  <div>
                    <input
                      type="radio"
                      id="siteSl"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="lieuDeParticipation"
                      [value]="lieuMiniJPO[0]"
                      name="lieuDeParticipation"
                      [style.border]="
                        isFieldInvalid('lieuDeParticipation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="siteSl"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Saint-Louis (Le 28 Novembre 2025)</label
                    >
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="siteKa"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="lieuDeParticipation"
                      [value]="lieuMiniJPO[1]"
                      name="lieuDeParticipation"
                      [style.border]="
                        isFieldInvalid('lieuDeParticipation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="siteKa"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Kolda (Le 28 Novembre 2025)</label
                    >
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-2">
                  <div>
                    <input
                      type="radio"
                      id="siteKl"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="lieuDeParticipation"
                      [value]="lieuMiniJPO[2]"
                      name="lieuDeParticipation"
                      [style.border]="
                        isFieldInvalid('lieuDeParticipation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="siteKl"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Kaolack (Le 02 Décembre 2025)</label
                    >
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="siteMb"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="lieuDeParticipation"
                      [value]="lieuMiniJPO[3]"
                      name="lieuDeParticipation"
                      [style.border]="
                        isFieldInvalid('lieuDeParticipation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="siteMb"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Mbour (Le 02 Décembre 2025)</label
                    >
                  </div>
                  <!--End nouveau champ cca-->
                </div>
              </div>
              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl"
                  >III. SITUATION ACADEMIQUE ET PROFESSIONNELLE</span
                >
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="grid md:grid-cols-3 m-0 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:me-3">
                      Statut Actuel
                      <span style="color: red">*</span>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('professionnalSituation')"
                      style="color: #eb1c1c"
                    >
                      Champ requis !
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-2">
                  <div>
                    <input
                      type="radio"
                      id="jobLess"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="professionnalSituation"
                      value="eleve"
                      name="professionnalSituation"
                      [style.border]="
                        isFieldInvalid('professionnalSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="jobLess"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Élèves</label
                    >
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="student"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="professionnalSituation"
                      value="Étudiant"
                      name="professionnalSituation"
                      [style.border]="
                        isFieldInvalid('professionnalSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="student"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Étudiants</label
                    >
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="Sans Emploi"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="professionnalSituation"
                      value="diplome/sans emploi"
                      name="professionnalSituation"
                      [style.border]="
                        isFieldInvalid('professionnalSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="Sans Emploi"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Sans Emploi</label
                    >
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-2">
                  <div>
                    <input
                      type="radio"
                      id="otherStatus"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="professionnalSituation"
                      value="employe (cdd,cdi)"
                      name="professionnalSituation"
                      [style.border]="
                        isFieldInvalid('professionnalSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="otherStatus"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Professionnel</label
                    >
                  </div>
                  <!-- nouveau champs cca-->
                  <div>
                    <input
                      type="radio"
                      id="entreprefree"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="professionnalSituation"
                      value="entrepreneur ou freelance"
                      name="professionnalSituation"
                      [style.border]="
                        isFieldInvalid('professionnalSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="otherStatus"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Entrepreneur ou freelance</label
                    >
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="Partenaires"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="professionnalSituation"
                      value="Partenaire"
                      name="professionnalSituation"
                      [style.border]="
                        isFieldInvalid('professionnalSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="Partenaires"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Partenaire</label
                    >
                  </div>
                  <!--End nouveau champ cca-->
                </div>
              </div>

              <hr class="h-1 my-8 bg-green-500 border-0 dark:bg-gray-700" />

              <div
                class="flex justify-center items-center"
                *ngIf="filled"
                style="color: #eb1c1c"
              >
                Veuillez renseigner tous les champs requis!
              </div>
              <div
                class="flex justify-center items-center"
                *ngIf="erreur"
                style="color: #eb1c1c"
              >
                {{ infoResponse }}
              </div>

              <div class="flex justify-end items-center">
                <button
                  type="submit"
                  class="rounded-md w-48 h-12 px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 btn-login"
                  [disabled]="isSubmitting"
                  (click)="onSubmitForm()"
                >
                  Confirmer
                </button>
              </div>

              <div class="flex justify-center mt-8">
                <div
                  class="logo-icon"
                  style="background-image: url('assets/img/logo_force_n.png')"
                ></div>
              </div>
            </div>
          </form>
        </div>
      </app-card-form>
    </div>
  </div>
</div>

<!-- Les notifications! -->

<div
  *ngIf="alreadyConfirm"
  class="bg-cover bg-center h-screen w-screen"
  style="background-image: url('assets/img/01-BG_AC_Force_N.png')"
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-blue-500 w-12 h-12"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 8.5h.01M11 11h1v4m9-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>

            <h3
              class="mb-5 text-lg font-normal text-gray-800 dark:text-gray-400"
            >
              Cher(e) {{ infoResponse }}, vous avez déjà confirmé votre
              participation à l'activité {{ activity.nomActivity }}.
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="submitSuccess"
  class="bg-cover bg-center h-screen w-screen"
  style="background-image: url('assets/img/01-BG_AC_Force_N.png')"
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-green-500 w-12 h-12"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 12.75l2.25 2.25L15 10.5m5.25 1.5a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z"
              />
            </svg>

            <h3
              class="mb-5 text-lg font-normal text-gray-800 dark:text-gray-400"
            >
              Votre participation à l’activité {{ activity.nomActivity }} a bien
              été enregistrée.
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="!isLoading && noSession"
  class="bg-cover bg-center h-screen w-screen"
  style="background-image: url('assets/img/01-BG_AC_Force_N.png')"
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3
              class="mb-5 text-lg font-normal text-gray-800 dark:text-gray-400"
            >
              <h1 style="font-size: large">
                Inscriptions non encore ouvertes.
              </h1>
              Les Journées Portes Ouvertes ne sont pas encore disponibles pour
              l’inscription. Merci de votre intérêt ! Revenez très prochainement
              pour compléter votre formulaire dès l’ouverture officielle des
              inscriptions. Restez en contact avec nous sur
              <a style="color: blue" href="https://force-n.sn/"
                >https://force-n.sn/</a
              >
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
